import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import IdleTimer from '../lib/idle_timer.js';
import { calculateIdleTimeout } from '../lib/application-helpers.js';

var _class, _descriptor, _descriptor2, _descriptor3;

/**
 * Servizio Idle / Screensaver
 * Gestisce lo stato dello screensaver, la password di sblocco e il wiring
 * dell'IdleTimer per il device idle-lock.
 * Estratto dal god-controller application (maintainability 4.2), comportamento invariato.
 */
let IdleScreensaverService = (_class = class IdleScreensaverService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "showScreensaver", _descriptor2, this);
    _initializerDefineProperty(this, "screenPassword", _descriptor3, this);
  }
  /* istanbul ignore next -- device idle-timer wiring (IdleTimer instance + screensaver) (§11.4) */
  setIDleLock(idleTimeout = 1800000) {
    const handleTimeout = () => {
      this.showScreensaver = true;
      this.setIDleLock(idleTimeout);
    };
    const handleExpired = () => {
      // do something if expired on load
      // (was: showScreensaver = true)
    };

    // The timer self-cleans when it fires, but keep the handle so a service
    // teardown (tests, logout flows) can stop a timer that never fired.
    this._idleTimer?.cleanUp?.();
    this._idleTimer = new IdleTimer({
      timeout: idleTimeout,
      onTimeout: handleTimeout,
      onExpired: handleExpired
    });
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this._idleTimer?.cleanUp?.();
    this._idleTimer = null;
  }

  /**
   * Calcola il timeout di idle per lo screensaver
   * @returns {number|null} Timeout in millisecondi
   */
  calculateIdleTimeout() {
    return calculateIdleTimeout(this.session.option_field);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showScreensaver", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "screenPassword", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { IdleScreensaverService as default };
//# sourceMappingURL=idle-screensaver.js.map
